import contentTemplate from './templates/tour-content.tpl.html';

function tourContentDirective($compile) {
  return {
    restrict: 'E',
    template: contentTemplate,
    link(scope, element) {
      scope.$watch('tour.currentStepIndex', () => {
        const elem = element.children(0);
        elem.empty();
        elem.replaceWith($compile(contentTemplate)(scope));
      });
    }
  };
}
tourContentDirective.$inject = ['$compile'];
export default tourContentDirective;
